var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFilledQuestion = function SvgFilledQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.3c8.7 0 15.7 7 15.7 15.7s-7 15.7-15.7 15.7-15.7-7-15.7-15.7 7-15.7 15.7-15.7zm-.2 20.6c-.7 0-1.3.2-1.8.7s-.7 1.1-.7 1.8.2 1.3.7 1.8c.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7c.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.4-1.1-.7-1.8-.7zm.4-14.3c-1.9 0-3.5.5-4.6 1.4-1 .9-1.6 2-1.7 3.4v.4h4.2c0-.3 0-.6.1-.8s.2-.4.4-.6c.3-.3.8-.5 1.4-.5.5 0 1 .2 1.4.6.4.4.6.9.6 1.4 0 .7-.2 1.3-.7 1.6-.4.3-1 .5-1.7.5H29.9v5.1h4.2v-2.6c.6 0 1.1-.1 1.6-.3.5-.2.9-.6 1.3-1 .7-.9 1.1-2 1.1-3.3 0-1.6-.5-3-1.6-4-1.1-.8-2.5-1.3-4.3-1.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    color: "currentColor",
    clip: "currentColor"
  })));
};
export default SvgFilledQuestion;